import { SelectOption } from "@pulseops/common"

export namespace OBCallingResultDetailFrom {
    export type OBQuestionAnswerInfo = {
        questionItem: SelectOption
        answerItem: SelectOption | undefined | null
        answerNote: string
        calendar: Date | null
    }
    export type OBCallingResultDetailData = {
        questionAnswerList: Array<OBQuestionAnswerInfo>,
        detailNote: string,
        customerBehavior: string,
        isCustomerPhoneUse: boolean
    }
}